import { Component, Input } from '@angular/core';
import { Patient } from '../../../models/patient';
import { TraitementDataComponent } from '../traitement-data/traitement-data.component';
import { PressionPipe } from '../../../pipes/pression.pipe';
import { ALaDateDuPipe } from '../../../pipes/a-la-date-du.pipe';

@Component({
  selector: 'app-traitement-data-pression-fixe',
  standalone: true,
  imports: [
    TraitementDataComponent,
    PressionPipe,
    ALaDateDuPipe
  ],
  templateUrl: './traitement-data-pression-fixe.component.html',
  styleUrl: './traitement-data-pression-fixe.component.scss',
})
export class TraitementDataPressionFixeComponent {
  @Input() patient: Patient | undefined;
}
